// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TurnstileCaptcha-module__turnstileCaptcha__rdpNL {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.TurnstileCaptcha-module__turnstileCaptchaError__Nrbrt {}

.TurnstileCaptcha-module__turnstileCaptcha__rdpNL iframe {
  border-radius: var(--mantine-radius-md);
}
`, "",{"version":3,"sources":["webpack://./src/features/application-form/TurnstileCaptcha.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,wDAAwB;;AAExB;EACE,uCAAuC;AACzC","sourcesContent":[".turnstileCaptcha {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.turnstileCaptchaError {}\n\n.turnstileCaptcha iframe {\n  border-radius: var(--mantine-radius-md);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"turnstileCaptcha": `TurnstileCaptcha-module__turnstileCaptcha__rdpNL`,
	"turnstileCaptchaError": `TurnstileCaptcha-module__turnstileCaptchaError__Nrbrt`
};
module.exports = ___CSS_LOADER_EXPORT___;
